<template>
  <div class="container">
    <div class="row">
      <!-- Item -->
      <div class="col parentElement" :class="{'flowdiagram' : mode === 'editor'}" :style="'height: ' + extra.height + 'px; position: relative;'">
        <drag-it-dude
          v-for="(item, index) in extra.points" :key="item.id" class="item" :id="item.id" :style="'left: ' + item.posX + '%;top: ' + item.posY + '%'"
          @activated="handleActivated"
          @dragging="handleDragging(index)"
          @dropped="handleDropped(index)"
        >
          <h1 :class="item.icon" :style="{ color: (item.color) ? item.color : '#666666', width: 50 + 'px' }"></h1>
          <div v-if="item.title">
            <small class="text-center" style="width: auto; font-size: 9pt">{{ item.title }}</small>
          </div>
          <small class="d-block" v-if="item.dataDevice && item.dataValue">{{ $store.getters.device(item.dataDevice)[item.dataValue] }} <span v-if="item.dataUnit">{{ item.dataUnit }}</span></small>
          <small class="d-block opacity-25" v-if="mode === 'editor'">{{ item.id }}</small>
        </drag-it-dude>
        <!--
        <div v-for="item in extra.points" :key="item.id" class="item" :id="item.id" :style="'left: ' + item.posX + '%;top: ' + item.posY + '%'">
          <h1 :class="item.icon" :style="{ color: (item.color) ? item.color : '#666666', width: 50 + 'px' }"></h1>
          <div v-if="item.title">
            <small class="text-center" style="width: auto; font-size: 9pt">{{ item.title }}</small>
          </div>
          <small class="d-block" v-if="item.dataDevice && item.dataValue">{{ $store.getters.device(item.dataDevice)[item.dataValue] }} <span v-if="item.dataUnit">{{ item.dataUnit }}</span></small>
          <small class="d-block opacity-25" v-if="mode === 'editor'">{{ item.id }}</small>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import LeaderLine from 'leader-line-vue'
import DragItDude from 'vue-drag-it-dude'
export default {
  props: ['title', 'extra', 'mode'],
  components: { DragItDude },
  data () {
    return {}
  },
  created () {},
  mounted () {
    const _this = this
    // Watchers
    if (this.mode !== 'editor') {
      this.extra.lines.forEach((line, index) => {
        if (!line.options.color) {
          line.options.color = '#0d6efd'
        }
        if (!line.options.path) {
          line.options.path = 'fluid'
        }
        line.obj =
          LeaderLine.setLine(
            document.getElementById(line.source),
            document.getElementById(line.target),
            line.options
          )

        // Start watcher for value if available
        if (line.dataDevice && line.dataValue && this.mode !== 'editor') {
          _this.$watch(() => _this.$store.getters.device(line.dataDevice)[line.dataValue], function (newValue, oldValue) { _this.lineValueUpdated(index) })
        }
        if (this.mode !== 'editor') {
          _this.lineValueUpdated(index)
        }
      })
    }
  },
  beforeDestroy () {
    if (this.mode !== 'editor') {
      this.extra.lines.forEach((line) => {
        line.obj.remove()
      })
    }
  },
  methods: {
    handleActivated () {
      console.log('dragging started')
    },
    handleDragging (index) {
      // console.log('Dragging item #', index)
      // this.lineValueUpdated(index)
    },
    handleDropped (index) {
      console.log('Updated position for item #', index)

      const point = this.extra.points[index]

      const parent = document.querySelector('.flowdiagram')
      const parentWidth = parent.offsetWidth
      const parentHeight = parent.offsetHeight
      // console.log(parentWidth, parentHeight)

      const element = document.querySelector('.flowdiagram #' + point.id)
      const elementX = element.offsetLeft
      const elementY = element.offsetTop
      // console.log(elementX, elementY)

      const posX = Number(((100 * elementX) / parentWidth).toFixed(2))
      const posY = Number(((100 * elementY) / parentHeight).toFixed(2))
      console.log(posX, posY)

      this.extra.points[index].posX = posX
      this.extra.points[index].posY = posY
      // this.lineValueUpdated(index)
    },
    lineValueUpdated (index) {
      if (this.mode !== 'editor') {
        const line = this.extra.lines[index]
        // const line = null
        const dataValue = this.$store.getters.device(line.dataDevice)[line.dataValue]
        const minValue = (line.dataMin) ? line.dataMin : 0
        // Remove old line
        line.obj.remove()

        let newSource = line.source
        let newTarget = line.target

        // Value is lower than minimum, reverse the direction
        if (dataValue < minValue) {
          newSource = line.target
          newTarget = line.source
          line.options.color = '#0d6efd'
          line.options.endPlug = 'arrow1'
          line.options.dash.animation = true

          // Value is higher than minimum, default direction
        } else if (dataValue > minValue) {
          newSource = line.source
          newTarget = line.target
          line.options.color = '#0d6efd'
          line.options.endPlug = 'arrow1'
          line.options.dash.animation = true
        }

        // Value is exactly minimum, no direction
        if (dataValue === minValue) {
          line.options.dash.animation = false
          line.options.endPlug = 'behind'
          line.options.color = '#cccccc'
        }

        // Draw line
        line.obj =
          LeaderLine.setLine(
            document.getElementById(newSource),
            document.getElementById(newTarget),
            line.options
          )
      }
    }
  }
}
</script>

<style>
.flowdiagram {
  background-size: 20px 20px;
  background-image:
    linear-gradient(to right, grey 1px, transparent 1px),
    linear-gradient(to bottom, grey 1px, transparent 1px);
}
.item {
  text-align: center;
  align-content: center;
  width: 75px;
  display: block;
  height: auto;
  z-index: 9;
  position: absolute;
}
</style>
